import React, { PureComponent } from 'react';
import ReactTable from 'react-table';

import { TableWrapper } from 'modules/list/table';

export default class CourseInfo extends PureComponent {
  render() {
    const { courseInfo } = this.props;

    const tableColumns = [
      {
        columns: [
          {
            Header: () => <div style={{ textAlign: 'center' }}>Course Name</div>,
            accessor: 'name',
            Cell: row => <div style={{ textAlign: 'center' }}>{row.value}</div>,
            width: 130,
          },
          {
            Header: () => <div style={{ textAlign: 'center' }}>Duration (months)</div>,
            accessor: 'duration',
            Cell: row => <div style={{ textAlign: 'center' }}>{row.value}</div>,
            width: 125,
          },
          {
            Header: () => <div style={{ textAlign: 'center' }}>Enrollment Type</div>,
            accessor: 'enrollment_type',
            Cell: row => <div style={{ textAlign: 'center' }}>{row.value}</div>,
            width: 100,
          },
          {
            Header: () => <div style={{ textAlign: 'center' }}>Class ratio</div>,
            accessor: 'class_ratio',
            Cell: row => <div style={{ textAlign: 'center' }}>{row.value}</div>,
            width: 80,
          },
          {
            Header: () => <div style={{ textAlign: 'center' }}>Access Type</div>,
            accessor: 'access_type',
            Cell: row => <div style={{ textAlign: 'center' }}>{row.value}</div>,
            width: 120,
          },
          {
            Header: () => <div style={{ textAlign: 'center' }}>Classes/week</div>,
            accessor: 'classes_per_week',
            Cell: row => <div style={{ textAlign: 'center' }}>{row.value}</div>,
            width: 100,
          },
        ],
      },
    ];
    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={courseInfo}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={true}
            defaultPageSize={3}
            columns={tableColumns}
            style={{ height: 110, overflowX: 'auto' }}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}
